import { PromoCustomer, ShareRecipient, ShareResult } from '../../types/promotions';
import { OUTCOME_CLASS, OUTCOME_LABEL, recipientLabel, WHATSAPP_UNAVAILABLE } from './shareModel';

/** Flow C step 5 — one line per recipient: shared / already held / not shared and why. */
export default function ShareResults({ results, sent, customers }: {
  results: ShareResult[];
  sent: ShareRecipient[];
  customers: PromoCustomer[];
}) {
  const whatsappOff = results.some((r) => r.outcome === 'CHANNEL_UNAVAILABLE');
  return (
    <div data-testid="share-results">
      {whatsappOff && (
        <div className="admin-info-banner warning" role="note" data-testid="whatsapp-unavailable">
          {WHATSAPP_UNAVAILABLE}. Share by email, or pick Email for customers who have one.
        </div>
      )}
      <ul className="promo-result-list">
        {results.map((r, i) => (
          <li key={i} data-testid="share-result">
            <span>{recipientLabel(sent[i], r, customers)}</span>
            <span className={`admin-badge ${OUTCOME_CLASS[r.outcome] ?? 'pending'}`}>{OUTCOME_LABEL[r.outcome] ?? r.outcome}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
